
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";

export class OnceCallbackContinueButton extends ContinueButton {

    private _onceClickCallback:Function | null;

    constructor() {
        super();
    }

    public addOnceClickCallback(callback:Function):void {
        this._onceClickCallback = callback;
    }

    protected onClick(event?:PIXI.InteractionEvent) {
        if(this._onceClickCallback) {
            this._onceClickCallback();
            this._onceClickCallback = null;
        }

        super.onClick(event);
    }
}